module.exports = __webpack_public_path__ + "img/1.7ad6226b.png";